import { Component, HostListener, Input, ElementRef } from '@angular/core';
import { Selectable } from '@reg/shared/model';

export class MultiSelectItem extends Selectable<any> {
    public displayName: string;

    constructor(model: any, displayName: string, isSelected: boolean = false, isEnabled: boolean = true) {
        super(model, isSelected, isEnabled);
        this.displayName = displayName;
    }
}

/**
 * Component to add/remove multiple items from a dropdown list
 */
@Component({
    selector: 'flo-multi-selection',
    templateUrl: './multi-selection.component.html',
    styleUrls: ['./multi-selection.component.scss'],
})
export class MultiSelectionComponent {
    @Input() public required: boolean = false;
    @Input() public isSubmitted: boolean = false;
    @Input() public selectName: string = '--Select--';
    @Input() public isLoading: boolean;
    @Input() public hasMultiplePages: boolean = false;

    @Input()
    public set items(items: MultiSelectItem[]) {
        if (this._items !== items) {
            this._items = items || [];
        }
    }

    public get items(): MultiSelectItem[] {
        return this._items;
    }

    private _items: MultiSelectItem[] = [];
    public isOpen: boolean;
    public searchText: string = '';

    public get selectedItems(): MultiSelectItem[] {
        return (this.items && this.items.filter((o: MultiSelectItem) => o.isSelected)) || [];
    }

    @HostListener('document:click', ['$event'])
    public clickout(event: MouseEvent): void {
        if (!this.eRef.nativeElement.contains(event.target)) {
            // User clicked outside the element so close the dropdown
            this.isOpen = false;
        }
    }

    public get isInvalid(): boolean {
        return this.isSubmitted && this.required && !this.selectedItems.length;
    }

    constructor(protected eRef: ElementRef) {
    }

    public onFilter(): void {
        this.items.forEach((o: MultiSelectItem) => {
            o.isEnabled =
                !this.searchText ||
                o.displayName.toLocaleLowerCase().indexOf(this.searchText.toLocaleLowerCase()) >= 0;
        });
    }

    public resetForm(): void {
        // Reset the form
        this.isOpen = false;
        this.required = false;
        this.isSubmitted = false;
        this.searchText = '';
    }

    /**
     * Override if paging is needed
     */
    public canLoadMore(): boolean {
        return false;
    }

    /**
     * Override to handle loading more pages
     */
    public onLoadMore(): void {
        // no-op override if needed to page
    }

    public onToggleSelection(item: MultiSelectItem, isSelected: boolean): void {
        item.isSelected = isSelected;
    }
}
